import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { useRefetchableQuery } from "core/hooks/useRefetchableQuery";
import {
  GetInquiryCheckouts_inquiryCheckoutConnections as GetInquiryCheckoutsConnectionsGenerated,
  GetInquiryCheckouts_inquiryCheckoutConnections_inquiries as GetInquiryCheckoutsConnectionsInquiryGenerated,
  GetInquiryCheckouts as GetInquiryCheckoutsGenerated,
  GetInquiryCheckoutsVariables as GetInquiryCheckoutsVariablesGenerated,
} from "core/queries/__generated__/GetInquiryCheckouts";

export interface GetInquiryCheckoutsVariables
  extends GetInquiryCheckoutsVariablesGenerated {}
export interface GetInquiryCheckoutsResponse
  extends GetInquiryCheckoutsGenerated {}
export interface GetInquiryCheckoutsConnections
  extends GetInquiryCheckoutsConnectionsGenerated {}

export interface GetInquiryCheckoutsConnectionsInquiry
  extends GetInquiryCheckoutsConnectionsInquiryGenerated {}

export const getInquiryCheckouts = gql`
  query GetInquiryCheckouts(
    $filters: InquiryCheckoutFilterInput!
    $sort: [InquiryCheckoutSortInput!]
  ) {
    inquiryCheckoutConnections(filters: $filters, sort: $sort) {
      total
      cursor
      hasMore
      inquiries {
        id
        account {
          id
          firstName
          lastName
        }
        guestActualDepartureTime {
          id
          actualDepartureTime
          channel
        }
        checkOutTime
        checkOutStatus
        lateCheckOutRequest {
          id
          eciLcoRequestId
          status
        }
        unit {
          id
          internalRef
          shortInternalRef
          aptNumber
        }
      }
    }
  }
`;

export interface UseGetInquiryCheckoutsQueryOptions {
  skip: boolean;
  variables: GetInquiryCheckoutsVariables;
}

export const useGetInquiryCheckoutsQuery = ({
  skip = false,
  variables,
}: UseGetInquiryCheckoutsQueryOptions) =>
  useQuery<GetInquiryCheckoutsResponse, GetInquiryCheckoutsVariables>(
    getInquiryCheckouts,
    {
      fetchPolicy: "cache-and-network",
      skip,
      variables,
    },
  );

export interface UseRefetchableGetInquiryCheckoutsQueryOptions
  extends UseGetInquiryCheckoutsQueryOptions {
  pollInterval: number;
}

export const useRefetchableGetInquiryCheckoutsQuery = ({
  pollInterval,
  skip,
  variables,
}: UseRefetchableGetInquiryCheckoutsQueryOptions) =>
  useRefetchableQuery<
    GetInquiryCheckoutsResponse,
    GetInquiryCheckoutsVariables
  >(getInquiryCheckouts, {
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    pollInterval,
    skip,
    variables,
  });
